<script>
import gsap from 'gsap'
export default {
    methods: {
        onBeforeEnter(el) {
            el.style.opacity = '0';
        },   
        onEnter(el) {
            gsap.fromTo(el,{
                opacity: 0,
                y: 50,
            },{
                duration: 1,
                y: 0,
                opacity: 1,
                ease:'back.out(1.2)'
            });
        },
        onBeforeEnter1(el) {
        },   
        onEnter1(el) {
            gsap.fromTo(el,{
                y: 50,
                opacity: 0,                
            },{
                duration: 1,
                y: 0,
                opacity: 1,
                delay: 0.8,
                ease: "bounce.out",
            });
        },
    }
}
</script>
<script setup>
import BigArrow from './icons/icon-arrow-up-big.vue'
</script>

<template lang="pug">
div(class="col-12 align-items-center my-header d-flex")
    div.col-1.text-end
        transition(appear @before-enter="onBeforeEnter1" @enter="onEnter1")
            BigArrow 
    div.col-11.ps-2
        transition(appear @before-enter="onBeforeEnter" @enter="onEnter")
            h2 <slot></slot>
</template>

<style lang="sass" scoped>
.my-header
    margin-top: 2rem
    color: var(--clr-yellow)
    margin-bottom: 2rem

h2
    font-size: 2rem
    text-transform: uppercase
    line-height: 2.2rem 
    @media (min-width: 768px)
        font-size: 3rem
        text-transform: uppercase
        line-height: 3.2rem
</style>